import React, { createContext, useState } from 'react';
import locales from './locales';

export const I18nContext = createContext();

const I18nContextProvider = ({ children }) => {
  const [pending, setPending] = useState(false);
  const [currentLocale, setCurrentLocale] = useState(
    locales[localStorage.getItem("wolteLanguage")] ??
    locales["pl"]
  );
  const [language, setLanguage] = useState(
    localStorage.getItem("wolteLanguage") || "pl"
  );

  const changeLanguage = (locale) => {
    return new Promise((resolve) => {
      setPending(true);
      setTimeout(() => {
        localStorage.setItem("wolteLanguage", locale);
        setLanguage(locale);
        setCurrentLocale(locales[locale]);
        setPending(false);
        resolve();
      }, 100);
    });
  };

  const toggleLanguage = () => {
    const current = localStorage.getItem("wolteLanguage") || "en";
    localStorage.setItem("wolteLanguage", current === 'en' ? 'pl' : 'en');
    setLanguage(current === 'en' ? 'pl' : 'en');
    setCurrentLocale(locales[current === 'en' ? 'pl' : 'en']);
  };

  const t = (key, textCase) => {
    let text = currentLocale[key] || key;
    switch (textCase) {
      case "lower":
        return text;
      case "upper":
        return text.toUpperCase();
      case "title":
        return toTitleCase(text);
      case "asIs":
        return text;
      default:
        return toProperCase(text);
    }
  };

  const toProperCase = (txt) =>
    txt?.length ? txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase() : txt;
  const toTitleCase = (str) => str.replace(/\w\S*/g, toProperCase);

  return (
    <I18nContext.Provider value={{ pending, changeLanguage, t, language, toggleLanguage }}>
      {children}
    </I18nContext.Provider>
  );
};

export default I18nContextProvider;
